module.exports = __webpack_public_path__ + "img/w3_close_black.c63fc026.png";